import "./App.css";
import React, { useState, useEffect } from "react";

function App() {
  const [inputData, setInputData] = useState("");
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [link, setLink] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (inputData.length > 2) {
      setShow(true);
      fetch(
        `https://dev.bi-me.co.za/api/v1/occupation/search?query=${inputData}&max=500`,
        {
          method: "GET",
          mode: "cors",
          headers: { "Content-Type": "text/html" }
        }
      )
        .then((response) => response.json())
        .then((data, i) => {
          if (data.length > 0) {
            console.log();
            setData(data);
          } else {
            setData([
              {
                occupations: [
                  {
                    occupationCode: "#",
                    occupationName: "No Results",
                    industryCode: "#"
                  }
                ],
                groupName: "No Results"
              }
            ]);
          }
        })
        .catch((e) => {
          console.log("An Error Occured");
          console.error(e);
          setData([
            {
              occupations: [
                {
                  occupationCode: "#",
                  occupationName: "Opps Something went wrong!",
                  industryCode: "#"
                }
              ],
              groupName: "Opps"
            }
          ]);
        });
    }
  }, [inputData]);

  const onClickHandle = (value) => {
    setShow(false);

    if (value.occupationName) {
      setSelectedValue(value.occupationCode);
      setLink(value.occupationName);
      setInputData("");
    } else {
      setSelectedValue("");
      setInputData("");
      setData([]);
    }
  };

  return (
    <section style={{ display: "flex", justifyContent: "center" }}>
      <div className="autoComplete_wrapper">
        <div className="inputInnerContainer">
          <input
            id="autocomplete-input"
            type="text"
            dir="ltr"
            spellcheck="false"
            autocorrect="off"
            autocomplete="off"
            autocapitalize="off"
            maxlength="2048"
            tabindex="1"
            aria-controls="autoComplete_list_1"
            aria-autocomplete="both"
            placeholder={link || "Search for your occupation"}
            aria-activedescendant=""
            value={inputData}
            onChange={(e) => setInputData(e.target.value)}
            onFocus={() => setShow(true)}
          />
          {selectedValue ? (
            <a
              target="_PARENT"
              href={`https://insure.bi-me.co.za/quote/buynow?occ=${selectedValue}`}
            >
              Get Started
            </a>
          ) : (
            <a
              target="_PARENT"
              href="https://bi-me.co.za/"
              className="disabled-link"
            >
              Get Started
            </a>
          )}
        </div>
       
        <ul id="autocomplete-results">
          {show === true &&
            data.length > 0 &&
            data.map((res, i) => {
              return (
                <>
                  <li
                    key={res.groupName}
                    style={{ color: "#8e969c", textTransform: "uppercase" }}
                  >
                    {res.groupName}
                  </li>

                  {res.occupations.map((d, i) => {
                    return (
                      <li onClick={() => onClickHandle(d)} key={i}>
                        {d.occupationName}
                      </li>
                    );
                  })}
                </>
              );
            })}
        </ul>

        <span id="loader">
          <svg
            width="25"
            height="25"
            viewBox="0 0 38 38"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#00b5e1"
          >
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </g>
            </g>
          </svg>
        </span>
      </div>
    </section>
  );
}

export default App;
